import type { FaireProductEntity } from "../../entity_types/product";

export const p_vzcvj7tksz: FaireProductEntity = {
  token: "p_vzcvj7tksz",
  type: "product",
  name: "Luna Lamb - Organic Sherpa Knit Stuffed Animal Baby Toy",
  brandToken: "b_7fghelgl",
  brandName: "Viverano Organics",
  imageUrl:
    "https://cdn.faire.com/fastly/fabb625aedbeb9409514ee9024983d69aab67f85872031f2a40606538c166ad8.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/dd6c754427dc5c22740f02c6b5e0675f51319e82cce1290797bc65b83392ee74.jpeg",
    "https://cdn.faire.com/fastly/caf23f228f1c53d9eddda8f053bda3c6018c1dda6e97fc1f748fe548bb36859f.jpeg",
    "https://cdn.faire.com/fastly/9326343343fa6fd27947786afa0f94cdeebacbc41dc76d2ec8718a916cd259ad.jpeg",
    "https://cdn.faire.com/fastly/c81ac1c53c3b84f0545f1f2130cb4fcb1d2c5fd7e655cb1a81938113ac60a852.jpeg",
  ],
  priceDollars: 20,
  description:
    'Viverano Organic Cotton Knitted Animal Stuffed Toys\nDiscover the perfect blend of quirkiness and cuddles with our organic cotton knit animal toys, designed to comfort and soothe your little ones while sparking joy and imagination.\n\nSoft & Cuddly: Crafted with a 100% organic cotton outer shell and filled with poly-fill for a plush, huggable feel.\nPerfect Size: Approximately 11" tall, ideal for little hands to hold and snuggle.\nImaginative & Unique: Fresh designs that bring delight to babies, kids, and even adults, perfect for buddy adventures, good company, and bedtime snuggles.\nHeirloom Quality: Lovingly made by hand with meticulous construction, ensuring durability and charm.\nSafe & Eco-Friendly: Non-toxic, GOTS-certified organic materials, safe for hugging and snuggling. Slight color variations and imperfections add to the unique, one-of-a-kind character of each piece.\nEasy Care: Machine washable with cool water and non-toxic detergent. Fluff in the dryer for a few minutes and air dr',
  tags: [],
  msrpDollars: 40,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-13T18:02:30.320Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
